import { useLayoutContext } from "hooks/routingHooks";
import { useEnabledMasks } from "hooks/maskHooks";
import { useSelection } from "hooks/selectionHooks";

import { MaskWMSLayer } from "./MaskWMSLayer";

export function MaskLayers() {
  const { settings, config } = useLayoutContext();
  const { data: selection } = useSelection(config, settings.layerProperties);
  const { data: enabledMasks } = useEnabledMasks(settings.masks);
  const { length } = selection?.indicators || [];

  if (!enabledMasks) return null;
  return (
    <>
      {enabledMasks.map((mask, i) => {
        const [wmsLayer] = mask.layers;
        return (
          <MaskWMSLayer
            key={mask.id}
            layer={wmsLayer}
            zIndex={length + (i + 2)}
          />
        );
      })}
    </>
  );
}
